import React from 'react';
import Sidebar from './components/Sidebar';

function DefaultLayout({ children }) {
  return (
    <div className="flex">
      <Sidebar />
      <div className="p-8 w-full overflow-auto flex-auto">
        {children}
      </div>
    </div>
  );
}

export { DefaultLayout };
